<template lang="pug">
  CardView(
    v-if='playlist'
    type='favorites'
    link='/tracks/favorite'
    :running='running'
    :title='$l10n("I_LIKE")'
    @play='$emit("play")'
    @pause='$emit("pause")'
    @delete='$emit("delete")'
  )
</template>

<script>
import CardView from "@/components/CardView/CardView";

export default {
  name: "PlaylistFavoritesView",
  props: ["playlist", "running"],
  components: {
    CardView
  }
};
</script>
